import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AccessPortalComponent} from './components/access-portal/access-portal.component';

const routes: Routes = [
  {path: '', component: AccessPortalComponent},
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
